(() => {
  const tag = 'fp-delivery-timeline';
  if (customElements.get(tag)) return;

  const addBusinessDays = (start, count) => {
    const result = new Date(start);
    let remaining = count;
    while (remaining > 0) {
      result.setUTCDate(result.getUTCDate() + 1);
      if (result.getUTCDay() !== 0 && result.getUTCDay() !== 6) remaining -= 1;
    }
    return result;
  };

  const addCalendarDays = (start, count) => {
    const result = new Date(start);
    result.setUTCDate(result.getUTCDate() + count);
    return result;
  };

  const shopDate = (now, timeZone) => {
    const parts = new Intl.DateTimeFormat('en-CA', {
      timeZone, year: 'numeric', month: '2-digit', day: '2-digit'
    }).formatToParts(now);
    const value = (type) => Number(parts.find((part) => part.type === type).value);
    return new Date(Date.UTC(value('year'), value('month') - 1, value('day'), 12));
  };

  class DeliveryTimeline extends HTMLElement {
    connectedCallback() {
      this.renderDates();
      this.interval = setInterval(() => this.renderDates(), 60000);
      this.onVisible = () => { if (!document.hidden) this.renderDates(); };
      document.addEventListener('visibilitychange', this.onVisible);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
      document.removeEventListener('visibilitychange', this.onVisible);
    }

    renderDates() {
      try {
        const today = shopDate(new Date(), this.dataset.timeZone);
        const locale = this.dataset.locale || 'en';
        const formatter = new Intl.DateTimeFormat(locale, { month: 'short', day: 'numeric', timeZone: 'UTC' });
        const format = (date) => formatter.format(date);
        const productionMin = Number(this.dataset.productionMin);
        const productionMax = Number(this.dataset.productionMax);
        const transitMax = Number(this.dataset.transitMax);
        this.querySelector('[data-fp-dt-order]').textContent = format(today);
        if (productionMax > 0) {
          const min = addBusinessDays(today, productionMin);
          const max = addBusinessDays(today, productionMax);
          const shipped = this.querySelector('[data-fp-dt-shipped]');
          shipped.textContent = min.getTime() === max.getTime() ? format(max) :
            (formatter.formatRange ? formatter.formatRange(min, max) : `${format(min)}–${format(max)}`);
          if (transitMax > 0) {
            const arrival = this.dataset.transitUnit === 'calendar'
              ? addCalendarDays(max, transitMax)
              : addBusinessDays(max, transitMax);
            this.querySelector('[data-fp-dt-arrival]').textContent = `${format(arrival)}*`;
          }
        }
        this.dataset.calculatedOn = today.toISOString().slice(0, 10);
      } catch (_) {
        this.dataset.dateFallback = 'true';
      }
    }
  }
  customElements.define(tag, DeliveryTimeline);
})();
